import truncate from 'lodash/truncate';

import { UserType } from '../constants/user.constants';

export const getUserRole = user => user?.userType === UserType.OWNER ? 'Owner' : 'Collaborator'

export const getUserDisplayName = (user, truncateAt = 48) => {
  const result = user?.email || user?.username || 'Removed User';

  return truncate(result, {
    length: truncateAt,
    separator: /([.@\s])+/,
  });
};
